import { SignupFlowSlug, flowPages } from "../constants";
import { useSignupFlowErrorStore } from "../hooks/useSignUpFlowErrorStore";
import {
  findFirstIncompletePage,
} from "../../../shared/findFirstIncompletePage";

import { getRequiredFieldsForSlug } from "./validateSignUpField";

export function findFirstIncompleteSignupPage(
  beforeSlug?: SignupFlowSlug,
): SignupFlowSlug | null {
  const { validatedFields } = useSignupFlowErrorStore.getState();
  let slugs = flowPages.map((p) => p.slug);

  if (beforeSlug) {
    const idx = slugs.indexOf(beforeSlug);
    if (idx !== -1) {
      slugs = slugs.slice(0, idx);
    }
  }

  return findFirstIncompletePage({
    slugs,
    getRequiredFieldsForSlug,
    validatedFields,
  });
}
